import { SVGProps } from "react";

const QuestionMarkCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={30} cy={30} r={30} fill="#F5FAFF" />
    <g clipPath="url(#clip0_10767_129077)">
      <circle cx={29.6898} cy={29.6898} r={18.8773} stroke="currentColor" />
      <path
        d="M25.0781 25.5985C25.0781 24.4803 25.5097 23.4079 26.278 22.6172C27.0462 21.8265 28.0882 21.3823 29.1747 21.3823H30.3452C31.4316 21.3823 32.4736 21.8265 33.2419 22.6172C34.0101 23.4079 34.4417 24.4803 34.4417 25.5985C34.4848 26.5109 34.2799 27.4155 33.8576 28.1759C33.4354 28.9364 32.8189 29.5115 32.1008 29.8147C31.3828 30.2189 30.7662 30.9857 30.344 31.9996C29.9218 33.0135 29.7168 34.2196 29.7599 35.4362"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={1.56154}
        cy={1.56154}
        r={1.56154}
        transform="matrix(1 0 0 -1 28.1992 41.6836)"
        fill="#007AF5"
      />
    </g>
    <defs>
      <clipPath id="clip0_10767_129077">
        <rect width={42} height={42} fill="white" transform="translate(9 9)" />
      </clipPath>
    </defs>
  </svg>
);
export default QuestionMarkCircle;
